import React, { useState, useEffect } from 'react';
import CropSelector from './CropSelector';
import Slider from 'react-slick';
import { Paper, Box, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AgricultureIcon from '@mui/icons-material/Agriculture';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useTranslation } from 'react-i18next';
import { getFarmerFarms } from '../../api/farm';

const FarmCarousel = ({ setSelectedFarmId, selectedFarmId, selectedCropId, setSelectedCropId }) => {
  const { t } = useTranslation();
  const [farms, setFarms] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    getFarmerFarms().then(setFarms).catch(console.error);
  }, []);

  const handleSelect = (id) => {
    setSelected(id);
    setSelectedFarmId(id);
  };

  const settings = {
    infinite: false,
    speed: 400,
    arrows: false,
    swipeToSlide: true,
    slidesToShow: 3.2,
  };

  return (
    <Paper elevation={0} sx={{ p: 1, m:1, borderRadius: 3, bgcolor: '#fff' }}>
      <Typography variant='h6' textAlign='center'>
      {t("Select your farm")} 
      </Typography>
      <Slider {...settings}>
        {farms.map((farm) => (
          <Box key={farm.id} px={1}>
            <Paper
              onClick={() => handleSelect(farm.id)}
              sx={{
                height: '7rem',
                borderRadius: 2,
                p: 1,
                m: 1,
                textAlign: 'center',
                cursor: 'pointer',
                bgcolor: selected === farm.id ? 'green.100' : 'white',
                border: selected === farm.id ? '2px solid #2e7d32' : '1px solid #ddd',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center', 
              }}
            >
              <Box>
                <Box display="flex" justifyContent="center" mb={1}>
                  <AgricultureIcon size={28} color="#2e7d32" />
                </Box>
                <Typography fontSize={12} fontWeight={600} mb={0.5} noWrap>
                  {farm.farm_name.length > 15 ? `${farm.farm_name.slice(0, 15)}...` : farm.farm_name}
                </Typography>
                <Typography fontSize={12} color="text.secondary">
                  {farm.area} {t("acres")}
                </Typography>
                <Typography fontSize={12} mb={2} color="text.secondary">
                {t("Farm ID:")} {farm.id} 
                </Typography>
                {selected === farm.id && (
                  <Box position="absolute" color="#2e7d32" bottom={1} right={3}>
                    <CheckCircleIcon size={18} color="#2e7d32" />
                  </Box>
                )}
              </Box>
            </Paper>
          </Box>
        ))}
      </Slider>
      {
        selectedFarmId &&
        <CropSelector selectedFarmId={selectedFarmId} selectedCropId={selectedCropId} setSelectedCropId={setSelectedCropId} />
      }
      <Typography variant="body1" mt={2} textAlign="center">
      {t("Or simply ask a question below")}
      </Typography>

    </Paper>
  );
};

export default FarmCarousel;
